import React from 'react';
import { Button } from 'react-bootstrap';
import { Upload, Download, FileText } from 'lucide-react';

import SettingsCard from '../SettingsCard';
import FileDropZone from '../../SharedComponents/FileDropZone';

// SIE import/export — its own settings route since the Bokföring split.
//
// The old markup nested three levels of box for this (card → import-export-card
// → export-option). Import and export are now two columns separated by a rule,
// so there is one border on screen instead of three.
const ImportExportSection = ({
  files,
  setFiles,
  isLoading,
  handleUpload,
  handleOpenExportModal,
}) => (
  <SettingsCard
    id="import-export"
    icon={Upload}
    title="Import & export"
    subtitle="Importera och exportera bokföringsdata från och till andra system"
  >
    <div className="settings-split">
      <section className="settings-split__pane">
        <h3 className="settings-subheading">
          <Download size={16} aria-hidden="true" />
          Importera data
        </h3>
        <p className="settings-help">
          Importera bokföringsdata från andra system via SIE-filer.
        </p>

        <FileDropZone
          setFiles={setFiles}
          fileTypes=".se"
          minHeight="120px"
          subText="Dra och släpp .se fil här eller klicka för att välja"
          acceptedFileTypes=".se"
          multiple="false"
        />

        <Button
          variant="primary"
          onClick={handleUpload}
          disabled={isLoading || files.length === 0}
          className="w-100 mt-3"
        >
          <Upload className="me-2" size={16} />
          {isLoading ? 'Kontrollerar...' : 'Kontrollera och importera'}
          {isLoading && <span className="spinner-border spinner-border-sm ms-2" />}
        </Button>
      </section>

      <section className="settings-split__pane">
        <h3 className="settings-subheading">
          <Upload size={16} aria-hidden="true" />
          Exportera data
        </h3>
        <p className="settings-help">
          Exportera bokföringsdata till andra system i olika format.
        </p>

        <ul className="settings-option-list">
          <li className="settings-option">
            <div className="settings-option__text">
              <FileText size={16} aria-hidden="true" />
              <div>
                <span className="settings-option__name">SIE-format</span>
                <small>Standardformat för svenska system</small>
              </div>
            </div>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handleOpenExportModal}
              disabled={isLoading}
            >
              <Download size={14} className="me-1" />
              Exportera
            </Button>
          </li>

          <li className="settings-option is-disabled">
            <div className="settings-option__text">
              <FileText size={16} aria-hidden="true" />
              <div>
                <span className="settings-option__name">CSV-format</span>
                <small>Comma-separated values för Excel</small>
              </div>
            </div>
            <span className="settings-option__soon">Snart</span>
          </li>

          <li className="settings-option is-disabled">
            <div className="settings-option__text">
              <FileText size={16} aria-hidden="true" />
              <div>
                <span className="settings-option__name">Excel-format</span>
                <small>Excel-arbetsbok (.xlsx)</small>
              </div>
            </div>
            <span className="settings-option__soon">Snart</span>
          </li>
        </ul>
      </section>
    </div>
  </SettingsCard>
);

export default ImportExportSection;
